import bankingService from "../../components/Services/banking.service";
import { GET_BANKING_CAPACITY_ALL, GET_BANKING_SEARCH } from "./types";

export const getBankingCapacityall = () => async (dispatch) => {
    bankingService.getAllMyBankingListing()
        .then((response) => {
            if (response && response.data.code === 200) {
                dispatch({ type: GET_BANKING_CAPACITY_ALL, payload: response?.data?.data });
            }
        }).catch(err => console.log(err))
}

export const getBankingSearch = () => async (dispatch) => {
    bankingService.getAllBankingList()
        .then((response) => {
            if (response && response.data.code === 200) {
                dispatch({ type: GET_BANKING_SEARCH, payload: response?.data?.data });
            }
        }).catch(err => console.log(err))
}